import { render, staticRenderFns } from "./SliderBox.vue?vue&type=template&id=55d7e6af&scoped=true&"
import script from "./SliderBox.vue?vue&type=script&lang=js&"
export * from "./SliderBox.vue?vue&type=script&lang=js&"
import style0 from "./SliderBox.vue?vue&type=style&index=0&id=55d7e6af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7e6af",
  null
  
)

export default component.exports